export class UploadItem {
  row_no: number
  group_no: number
  page_no: string
  file_name: string
  base_sheet_id: number
  sheet_code: string
  sheet_code_cache: string
  sheet_name: string
  student_code: number
  student_name: string
  course_code: string
  course_name: string
  campus_code: string
  campus_name: string
  class_code: string
  class_name: string
  student_qr_code: string
  paper_qr_code: string
  dpi: number
  width: number
  height: number
  angle: number = 0
  errors: string[] = []
  disp_file_name: string
  is_use_hosei: boolean
  hosei_positions: number[][] = [];
  base_hosei_positions: number[][] = [];

  constructor(item: any){
    this.row_no = item.no;
    this.group_no = item.group_no;
    this.page_no = item.page_no;
    this.file_name = item.file_name;
    this.base_sheet_id = item.base_sheet_id;
    this.sheet_code = item.sheet_code;
    this.sheet_code_cache = item.sheet_code;
    this.sheet_name = item.sheet_name;
    this.student_code = item.student_code;
    this.student_name = item.student_name;
    this.course_code = item.course_code;
    this.course_name = item.course_name;
    this.campus_code = item.campus_code;
    this.campus_name = item.campus_name;
    this.class_code = item.class_code;
    this.class_name = item.class_name;
    this.paper_qr_code = item.paper_qr_code;
    this.student_qr_code = item.student_qr_code;
    this.dpi = item.dpi;
    this.width = item.width;
    this.height = item.height;
    this.errors = item.errors;
    const splitFilePath = item.file_name.split("/");
    this.disp_file_name = splitFilePath[splitFilePath.length - 1];
    this.is_use_hosei = item.is_use_hosei;

    if(item.hosei_positions != null){
      this.hosei_positions = item.hosei_positions;
    }

    if(item.base_hosei_positions != null){
      this.base_hosei_positions = item.base_hosei_positions;
    }
  }
}

export class ImageItem {
  fileName: string
  base64Image: string

  constructor(fileName: string, base64Image: string){
    this.fileName = fileName;
    this.base64Image = base64Image;
  }
}

export class SearchCondition {
  student_code: string = ""
  name: string = ""
  class_code: string = null
  page: number = 1
  row_count: number =  10
}

export class Student {
  student_code: number
  name: string
  class_code: number
  class_name: string
  isExistsClassification: boolean
  full_count: number

  constructor(student: any){
    this.student_code = student.student_code;
    this.name = student.name;
    this.class_code = student.class_code;
    this.class_name = student.class_name;
    this.isExistsClassification = student.is_exists_classification;
    this.full_count = student.full_count;
  }
}

export const DirectionEnum = Object.freeze({Left: 1, Right: 2});

export const rotateHoseiPosition = (hosei_positions: number[][], direction: number, angle: number, imageW: number, imageH: number) => {

  const newHoseiPositions: number[][] = [[-1, -1], [-1, -1], [-1, -1], [-1, -1]];

  const width = angle == 90 || angle == 270 ? imageW : imageH;
  const height = angle == 90 || angle == 270 ? imageH : imageW;

  hosei_positions.forEach((pos, i) => {
    if(direction == DirectionEnum.Left){
      if(i == 0){
        newHoseiPositions[1][0] = pos[1];
        newHoseiPositions[1][1] = width - pos[0];
      }else if(i == 1){
        newHoseiPositions[2][0] = pos[1];
        newHoseiPositions[2][1] = width - pos[0];
      }else if(i == 2){
        newHoseiPositions[3][0] = height - (height - pos[1]);
        newHoseiPositions[3][1] = width - pos[0];
      }else if(i == 3){
        newHoseiPositions[0][0] = pos[1];
        newHoseiPositions[0][1] = width - pos[0];
      }
    }else{
      if(i == 0){
        newHoseiPositions[3][0] = height - pos[1];
        newHoseiPositions[3][1] = pos[0];
      }else if(i == 1){
        newHoseiPositions[0][0] = height - pos[1];
        newHoseiPositions[0][1] = pos[0];
      }else if(i == 2){
        newHoseiPositions[1][0] = height - pos[1];
        newHoseiPositions[1][1] = pos[0];
      }else if(i == 3){
        newHoseiPositions[2][0] = height - pos[1];
        newHoseiPositions[2][1] = pos[0];
      }
    }
  });

  return newHoseiPositions;
}
